import luda from '../base/luda.coffee'
import './eq.coffee'


luda.include
  
  last: -> @eq -1